import React from 'react';
import { classNames } from '../../Services/helpers';
import { useSession } from '../Session';
import Icon from '../Icons/Icon';

const Badge = ({title, theme, className, icon}) => {
    const {showRedesign} = useSession();

    const themes = {
        'secondary': 'bg-gray-500/10 dark:bg-gray-500/30 text-gray-500 dark:text-gray-100 fill-gray-500 dark:fill-gray-100 ring-gray-500 dark:ring-gray-500',
        'danger': 'bg-red-500/10 dark:bg-red-500/30 text-red-500 dark:text-red-100 fill-red-500 dark:fill-red-100 ring-red-500 dark:ring-red-500',
        'warning': 'bg-orange-500/10 dark:bg-orange-500/30 text-orange-500 dark:text-orange-100 fill-orange-500 dark:fill-orange-100 ring-orange-500 dark:ring-orange-500',
        'info': 'bg-blue-500/10 dark:bg-blue-500/30 text-blue-600 dark:text-blue-100 fill-blue-600 dark:fill-blue-100 ring-blue-600 dark:ring-blue-600',
        'success': 'bg-green-500/10 dark:bg-green-500/30 text-green-500 dark:text-green-100 fill-green-500 dark:fill-green-100 ring-green-500 dark:ring-green-500',
        'brand': 'bg-brand/10 dark:bg-brand/50 text-brand dark:text-brand-light fill-brand dark:fill-brand-light ring-brand dark:ring-brand-light',
        'primary': 'bg-brand/10 dark:bg-brand/50 text-brand dark:text-brand-light fill-brand dark:fill-brand-light ring-brand dark:ring-brand-light',
    }

    const classes = classNames(
        'inline-flex items-center gap-1 px-2 py-1 text-xs font-medium shrink',
        theme && (themes[theme] ?? themes['secondary']),
        showRedesign ? 'ring-0 rounded-md' : 'ring-1 ring-inset rounded-full',
        className,
    );

    return <span className={classes}>
        {icon && <Icon icon={icon} theme="solid" size="0.5x" />}
        {title}
    </span>
}

export default Badge;
